import { AGREEMENT_STATUS } from 'options/agreementStatus';
import { PROJECT_STATUS } from 'options/projectStatus';
import { PROPOSAL_STATUS } from 'options/proposalStatus';

export const getIsProposalTabDisabled = (project_status) => {
  return project_status === PROJECT_STATUS.PENDING;
};

export const getIsAgreementTabDisabled = (project_status, proposal_status) => {
  return project_status === PROJECT_STATUS.REJECTED || proposal_status === PROPOSAL_STATUS.REJECTED;
};

export const getIsFilesTabDisabled = (agreement_status) => {
  return !(agreement_status === AGREEMENT_STATUS.UPFRONT_PAID || agreement_status === AGREEMENT_STATUS.PAID);
};

export const getIsProjectCompleted = (project_status) => {
  return project_status === PROJECT_STATUS.COMPLETED;
};
